// 261010 UI-directing — luật hiển thị thanh bộ lọc trạng thái (mọi bước theo video dùng chung MỘT thanh ở WorkflowStepBoard). THUẦN (không antd).
// Chip = biểu tượng + nhãn NGẮN tiếng Việt + số. Ẩn chip có số 0 (trừ «Tất cả»); «Cần xử lý» chỉ hiện khi > 0 và mang tông cảnh báo.
// Bộ lọc đang chọn mà số về 0 ⇒ rơi về «Tất cả» (không để thanh trống / danh sách rỗng mà không thấy chip nào sáng).
import { STATE_FILTERS, type StateFilter } from './workflowBoardUtils';
import { filterIconOf, type IconName } from './workflowStatusIcons';
import type { StateTone } from './workflowBoardUtils';

/** Nhãn ngắn hiện trên chip (nhãn đầy đủ ở Tooltip / aria-label). */
export const FILTER_SHORT_LABEL: Record<string, string> = {
  ATTN: 'Cần xử lý', ALL: 'Tất cả', ERROR: 'Lỗi', STALE: 'Cũ', RUNNING: 'Đang chạy', NOT_READY: 'Chưa tới', DONE: 'Xong',
};
/** Nhãn đầy đủ cho Tooltip («Có kết quả» giữ nghĩa cũ của bộ lọc DONE). */
export const FILTER_FULL_LABEL: Record<string, string> = {
  ATTN: 'Cần xử lý — video lỗi, thiếu kết quả hoặc đã cũ ở bước này', ALL: 'Tất cả video', ERROR: 'Video lỗi', STALE: 'Video đã cũ (dữ liệu trước đã đổi)',
  RUNNING: 'Video đang chạy', NOT_READY: 'Video chưa tới bước này', DONE: 'Video đã có kết quả',
};

export interface FilterChip { key: StateFilter; icon: IconName; tone: StateTone; short: string; full: string; count: number; attn: boolean }
export interface FilterBar { chips: FilterChip[]; /** Bộ lọc thật sự áp dụng (đã rơi về ALL nếu chip đã chọn bị ẩn). */ effective: StateFilter; /** false ⇒ chỉ còn «Tất cả» ⇒ không vẽ thanh. */ show: boolean }

/** `selected` đã qua `resolveStateFilter` (AUTO → ATTN/ALL). */
export function filterBarOf(counts: Partial<Record<StateFilter, number>>, attnTotal: number, selected: StateFilter): FilterBar {
  const mk = (key: StateFilter, count: number): FilterChip => {
    const fi = filterIconOf(key);
    return { key, icon: fi.icon, tone: key === 'ATTN' ? 'warn' : fi.tone, short: FILTER_SHORT_LABEL[key] ?? key, full: FILTER_FULL_LABEL[key] ?? key, count, attn: key === 'ATTN' };
  };
  const chips: FilterChip[] = [];
  if (attnTotal > 0) chips.push(mk('ATTN', attnTotal));
  for (const f of STATE_FILTERS) {
    const n = counts[f.key] ?? 0;
    if (f.key === 'ALL' || n > 0) chips.push(mk(f.key, n));
  }
  const effective = selected === 'AUTO' || !chips.some((c) => c.key === selected) ? 'ALL' : selected;
  return { chips, effective, show: chips.length > 1 };
}
